import { forwardRef, useImperativeHandle, useRef } from "react";
import TransactionListOverview from "../TransactionsAndCategoryOverview/TransactionsOverview/TransactionListOverview";

const cardStyleBase = {
    background: "white",
    margin: "10px",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    borderRadius: "10px",
    width: "510px"
};

export default forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        setItems: setItems
    }));
    const transactionListRef = useRef(null);

    const setItems = (items) => {
        transactionListRef.current.setItems(items);
    };
    return (
        <div dir={"rtl"} style={cardStyleBase}>
            <TransactionListOverview ref={transactionListRef}/>
        </div>
    );
});
